// Figma spec demo numbers — used only as explicit fallback ("Load demo data")
export const MOCK_GRC_DASHBOARD = {
  assessment_id: "demo-assessment",
  org_profile: { org_name: "Acme Fintech Pvt Ltd (Demo)", industry: "Financial Services" },
  last_imported_at: "2025-06-09T11:24:00+05:30",
  compliance_score: {
    overall_score: 62.4,
    readiness_band: "Advanced (L4)",
    readiness_rag: "YELLOW",
    trend_delta_pct: 6.8,
    trend_direction: "up",
  },
  maturity: {
    level: 4,
    label: "Established",
    band: "Advanced",
    penalty_exposure_text: "₹10–50 Crore exposure",
  },
  sdf: {
    flag: true,
    module_a_band: "HIGH",
    module_b_score: 75,
    module_b_rag: "YELLOW",
    module_b_activated: true,
  },
  gap_summary: { critical: 5, major: 12, minor: 20, pass: 40, total_active: 77 },
  pillars: {
    P1:  { code: "P1",  name: "Applicability & Data Inventory",         pct: 75, rag: "YELLOW", priority: null, weight_pct: 8 },
    P2:  { code: "P2",  name: "Consent Management & Notice",             pct: 58, rag: "AMBER",  priority: null, weight_pct: 10 },
    P3:  { code: "P3",  name: "Data Principal Rights",                   pct: 49, rag: "AMBER",  priority: null, weight_pct: 8 },
    P4:  { code: "P4",  name: "Data Security & Safeguards",              pct: 67, rag: "YELLOW", priority: null, weight_pct: 6 },
    P5:  { code: "P5",  name: "Breach Response & Notification",          pct: 41, rag: "AMBER",  priority: null, weight_pct: 6 },
    P6:  { code: "P6",  name: "Governance, Accountability & Training",   pct: 56, rag: "AMBER",  priority: null, weight_pct: 8 },
    P7:  { code: "P7",  name: "Third-Party & Cross-Border Management",   pct: 63, rag: "YELLOW", priority: null, weight_pct: 6 },
    P8:  { code: "P8",  name: "Children's Data & Special Categories",    pct: 72, rag: "YELLOW", priority: null, weight_pct: 7 },
    P9:  { code: "P9",  name: "SDF Readiness Screening",                 pct: null, rag: "YELLOW", priority: null, weight_pct: 8 },
    P10: { code: "P10", name: "Evidence Planner",                        pct: 38, rag: "RED",    priority: null, weight_pct: 6 },
    P11: { code: "P11", name: "Readiness Roadmap",                       pct: 44, rag: "AMBER",  priority: null, weight_pct: 6 },
    P12: { code: "P12", name: "Data Retention & Erasure Lifecycle",      pct: 61, rag: "YELLOW", priority: null, weight_pct: 7 },
    P13: { code: "P13", name: "Data Protection Impact Assessment (DPIA)", pct: 55, rag: "AMBER",  priority: null, weight_pct: 5 },
    P14: { code: "P14", name: "Grievance Redressal & DPB Escalation",    pct: 66, rag: "YELLOW", priority: null, weight_pct: 4 },
    P15: { code: "P15", name: "Privacy by Design",                       pct: 71, rag: "YELLOW", priority: null, weight_pct: 5 },
  },
  pillars_below_waterline_count: 12,
  waterline_pct: 75,
  compliance_deadline: "2027-05-14",
  days_until_deadline: 548,
  audit_deadline_warning: true,
  schema_version: "V2.2",
};
